exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-disk-list ul.list-inline {\n  margin-bottom: 0.5rem;\n}\n.fm-disk-list .badge.badge-light {\n  cursor: pointer;\n}", ""]);

// exports
